import * as types from './constants';

// Get Billing Subscription Info
export const getBillingSubscriptionInfoRequest = data => (
  { type: types.GET_BILLING_SUBSCRIPTION_INFO_REQUEST, payload: data }
);

export const getBillingSubscriptionInfoDone = data => (
  { type: types.GET_BILLING_SUBSCRIPTION_INFO_DONE, payload: data }
);

export const getBillingSubscriptionInfoFailed = errors => (
  { type: types.GET_BILLING_SUBSCRIPTION_INFO_FAILED, payload: errors }
);